import i18n from '@/locales/config';
import storage from '@/utils/authorization-util';

// 语言映射表
const LANGUAGE_MAP = {
  zh: 'zh',
  'zh-TW': 'zh-traditional',
  en: 'en',
} as const;

// 主题映射表
const THEME_MAP = {
  light: 'light',
  dark: 'dark',
} as const;

export interface DisplayData {
  system_language: string;
  system_theme: string;
}

// 处理显示数据同步
export const handleDisplayDataSync = (displayData: DisplayData) => {
  console.log('🎨 Received display data from parent:', displayData);

  try {
    // 同步语言
    const { system_language } = displayData;
    if (
      system_language &&
      LANGUAGE_MAP[system_language as keyof typeof LANGUAGE_MAP]
    ) {
      const ragflowLang =
        LANGUAGE_MAP[system_language as keyof typeof LANGUAGE_MAP];
      const currentLang = i18n.language;

      if (currentLang !== ragflowLang) {
        console.log(
          `🌍 Changing language from ${currentLang} to ${ragflowLang}`,
        );
        i18n.changeLanguage(ragflowLang);
        storage.setLanguage(ragflowLang);
      }
    }

    // 同步主题 - 直接触发主题变化事件
    const { system_theme } = displayData;
    if (system_theme && THEME_MAP[system_theme as keyof typeof THEME_MAP]) {
      const ragflowTheme = THEME_MAP[system_theme as keyof typeof THEME_MAP];

      console.log(`🎨 Setting theme to ${ragflowTheme}`);

      // 直接触发主题变化事件，让ThemeProvider处理
      window.dispatchEvent(
        new CustomEvent('theme-change', { detail: ragflowTheme }),
      );
    }
  } catch (error) {
    console.error('❌ Error handling display data sync:', error);
  }
};

// 检查是否在iframe中
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

// 全局消息处理器
export const setupGlobalMessageHandler = () => {
  if (!isInIframe()) return;

  const handleMessage = (event: MessageEvent) => {
    if (!event.data?.type) return;

    console.log('📨 Global message handler received:', event.data.type);

    switch (event.data.type) {
      case 'KNOWLEDGE_BASE_DISPLAY_DATA':
        handleDisplayDataSync(event.data.data);
        break;
      default:
        // 忽略其他消息类型
        break;
    }
  };

  window.addEventListener('message', handleMessage);
  console.log('✅ Global message handler setup complete');

  // 返回清理函数
  return () => {
    window.removeEventListener('message', handleMessage);
  };
};
